import { NgClass } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, input, output, signal } from '@angular/core';
import { ListingsScrollUtilsService } from 'listings/services/listingsScrollUtils.service';

/**
 * The content that shows at all times should have the class "mainContent".
 * The content that shows only when expanded should have the class "expandableContent".
 * To get the widget to display as a block, add the "block" class to the expando element.
 *
 * It accepts a few options:
 *      * defaultStateIsExpanded {boolean} (default = true);
 *      * onlyChevronExpands {boolean} (default = false);
 *
 * It also emits an expand event whenever the widget is expanded or contracted by the user.
 */

@Component({
    selector: 'app-dynamic-form-expando',
    templateUrl: './dynamic-form-expando.component.html',
    styleUrls: ['./dynamic-form-expando.component.scss'],
    imports: [NgClass],
})
export class DynamicFormExpandoComponent implements AfterViewInit {
    public contentExpanded = signal<boolean | undefined>(undefined);
    public level = input<number | null>(null);
    public defaultStateIsExpanded = input<boolean>(true);
    public onlyChevronExpands = input<boolean>(false);
    public exceptedFromToggle = input<ElementRef | null>(null);
    public expand = output<boolean>();

    isExpandable = input<boolean>(true);
    displayFullWidthHeader = input<boolean>(false);
    applyContentMargin = input<boolean>(true);
    centerChevron = input<boolean>(true);

    constructor(private listingsScrollUtilService: ListingsScrollUtilsService) {}

    public ngAfterViewInit() {
        this.listingsScrollUtilService.finalizeScrollToRetry();
        this.contentExpanded.set(this.defaultStateIsExpanded() ?? false);
        this.expand.emit(this.contentExpanded() ?? false);
    }

    public toggleExpandedContent(event: any, isIconClick = false): void {
        if (isIconClick) {
            event.stopPropagation();
        }

        if (!this.isExpandable()) {
            return;
        }

        if (this.exceptedFromToggle()?.nativeElement?.contains(event.target)) {
            return;
        }

        if (this.onlyChevronExpands() && !isIconClick) {
            return;
        }

        if (this.contentExpanded()) {
            this.closeExpandedContent();
        } else {
            this.openExpandedContent();
        }
    }

    public openExpandedContent() {
        this.contentExpanded.set(true);
        this.expand.emit(true);
    }

    public closeExpandedContent() {
        this.contentExpanded.set(false);
        this.expand.emit(false);
    }
}
